import ChartNivAcuutHartfalen from "../../../../src/client/niv_acuteboekje/json/acuut-hartfalen.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivAcuutHartfalen,
  ChartNivSimple,
  ButtonSchematic,
  React
};